// extracted by mini-css-extract-plugin
module.exports = {"LinkButton":"Link_LinkButton__2a1Mv"};